export function isUrlValid (url: string) {
    if(!url) return undefined;
    try{
        new URL(url);
        return undefined
    } catch (e){
        return 'lto.generic.invalid_url';
    }
  }